import { ModalHeader, Modal } from "reactstrap";

const ActionNotAllowedModel = ({
  msg,
  isOpen,
  handleClickCloseModalRequest,
  backdrop = true,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={handleClickCloseModalRequest}
        backdrop={backdrop}
      >
        <ModalHeader
          className="modal-header-no-button"
          toggle={handleClickCloseModalRequest}
        >
          {msg}          
        </ModalHeader>
      </Modal>
    </>
  );
};

export default ActionNotAllowedModel;
